<i
    class="bi cursor-pointer"
    [ngClass]="{
        'bi-question-circle': iconType === 'question',
        'bi-info-circle': iconType === 'info'
    }"
    [class]="color"
    [pTooltip]="message"
    tooltipPosition="top"
></i>